import { IList } from '@fluentui/react';

/**
 * Base class to manage the logic of scrolling and focusing on items within the GroupedListSection.
 */
export abstract class FocusWorker {
    private _pendingFocus = false;
    private _elementCreated = false;
    protected _list: React.RefObject<IList>;
    protected _root: React.RefObject<HTMLElement>;

    public constructor(list: React.RefObject<IList>, root: React.RefObject<HTMLElement>) {
        this._list = list;
        this._root = root;
    }

    /**
     * Scroll to the element that is managed by this class and then focus it.
     */
    public scrollAndFocus(itemCount: number): void {
        // scroll
        this.scrollToElementCore(itemCount);

        // check if the element has been created before we can focus on it.
        if (this._elementCreated) {
            this.focusElement();
        } else {
            this._pendingFocus = true;
        }
    }

    /**
     * Notify this worker when its element has just been created.
     */
    public onElementCreated(): void {
        this._elementCreated = true;

        if (this._pendingFocus) {
            this.focusElement();
            this._pendingFocus = false;
        }
    }

    /**
     * Notify this worker when its element has just been removed.
     */
    public onElementRemoved(): void {
        this._elementCreated = false;
    }

    protected abstract focusElement(): void;

    protected abstract scrollToElementCore(itemCount: number): void;
}
